import { createI18n } from 'vue-i18n'
import ru from './ru.json'
import en from './en.json'
import ky from './ky.json'
import { kycUi } from './kycUi'

function mergeMessages(base: Record<string, any>, extra: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = { ...base }
  for (const [key, value] of Object.entries(extra)) {
    const current = out[key]
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      current &&
      typeof current === 'object' &&
      !Array.isArray(current)
    ) {
      out[key] = mergeMessages(current, value)
    } else {
      out[key] = value
    }
  }
  return out
}

// Определяем поддерживаемые языки
export const supportedLocales = {
  ru: 'Русский',
  en: 'English',
  ky: 'Кыргызча'
}

// Создаем экземпляр i18n
const i18n = createI18n({
  legacy: false, // Используем Composition API
  locale: (() => { try { return localStorage.getItem('locale') } catch { return null } })() || 'ru',
  fallbackLocale: 'ru', // Язык для fallback
  messages: {
    ru: mergeMessages(ru, kycUi.ru),
    en: mergeMessages(en, kycUi.en),
    ky: mergeMessages(ky, kycUi.ky),
  },
  // Настройки форматирования
  numberFormats: {
    ru: {
      currency: {
        style: 'currency',
        currency: 'KGS',
        minimumFractionDigits: 2
      },
      decimal: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    },
    en: {
      currency: {
        style: 'currency',
        currency: 'KGS',
        minimumFractionDigits: 2
      },
      decimal: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    },
    ky: {
      currency: {
        style: 'currency',
        currency: 'KGS',
        minimumFractionDigits: 2
      },
      decimal: {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  },
  // Настройки дат
  datetimeFormats: {
    ru: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'Asia/Bishkek',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'Asia/Bishkek',
      }
    },
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'Asia/Bishkek',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'Asia/Bishkek',
      }
    },
    ky: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'Asia/Bishkek',
      },
      long: {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'Asia/Bishkek',
      }
    }
  }
})

export function translateMessage(key: string): string {
  const global = i18n.global as unknown as { t: (key: string) => unknown }
  const text = global.t(key)
  return typeof text === 'string' ? text : key
}

export default i18n 